import 'whatwg-fetch';
import '@babel/polyfill';
import { interop } from "./Interop";
import { chatClient } from "./ChatClient";
import { channelClient } from "./ChannelClient";

import {
    renderChatWindow,
    renderAvatar,
    focusChatTextBox,
    sendActivity
} from "./ChatWindow";

(window as any).ChatClient = chatClient;
(window as any).ChannelClient = channelClient;
(window as any).ChatWindow = {
    RenderChatWindow: renderChatWindow,
    RenderAvatar: renderAvatar,
    FocusChatTextBox: focusChatTextBox,
    SendActivity: sendActivity
};
(window as any).Interop = interop;

function chatClientBridge() {
    const [method, ...args] = Array.from(arguments);
    return ((window as any).ChatClient as any)[method](...args);
}
function channelClientBridge() {
    const [method, ...args] = Array.from(arguments);
    return ((window as any).ChannelClient as any)[method](...args);
}
function chatWindowBridge() {
    const [method, ...args] = Array.from(arguments);
    return ((window as any).ChatWindow as any)[method](...args);
}
function interopBridge() {
    const [method, ...args] = Array.from(arguments);
    return (interop as any)[method](...args);
}
(window as any).chatClientBridge = chatClientBridge;
(window as any).chatWindowBridge = chatWindowBridge;
(window as any).channelClientBridge = channelClientBridge;
(window as any).interopBridge = interopBridge;
